<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="dataSource"
    :row-key="(r) => r.id"
    :loading="loading"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'employee'">
        <div class="d-flex align-items-center file-name-icon">
          <a href="javascript:void(0);" class="avatar avatar-md border avatar-rounded">
            <img :src="record.employee?.avatar || require('@/assets/img/users/user-01.jpg')" class="img-fluid" alt="img" />
          </a>
          <div class="ms-2">
            <h6 class="fw-medium"><a href="javascript:void(0);">{{ record.employee?.name || '-' }}</a></h6>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'User_Available'">
        <div>
          <p class="mb-0">
            {{ fmtDate(record.date) }} -
            {{ fmtTime(record.start_time) }} - {{ fmtTime(record.end_time) }}
            <span v-if="record.break_minutes"> (Break {{ record.break_minutes }}m)</span>
          </p>

          <p class="mb-0 text-muted fs-12" v-if="record.min_start_time || record.max_start_time">
            Start Window: {{ fmtTime(record.min_start_time) }}–{{ fmtTime(record.max_start_time) }}
          </p>
          <p class="mb-0 text-muted fs-12" v-if="record.min_end_time || record.max_end_time">
            End Window: {{ fmtTime(record.min_end_time) }}–{{ fmtTime(record.max_end_time) }}
          </p>
        </div>
      </template>

      <template v-else-if="column.key === 'published'">
        <span class="badge" :class="record.published ? 'bg-success' : 'bg-secondary'">
          {{ record.published ? 'Published' : 'Draft' }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="d-flex gap-2">
          <button
            class="btn btn-sm btn-outline-primary"
            type="button"
            v-can="'ShiftSchedule.Edit'"
            @click="$emit('edit', record)"
          >
            <i class="ti ti-edit"></i>
          </button>
          <button
            class="btn btn-sm btn-outline-danger"
            type="button"
            v-can="'ShiftSchedule.Delete'"
            @click="$emit('delete', record)"
          >
            <i class="ti ti-trash"></i>
          </button>
        </div>
      </template>

      <template v-else-if="column.key === 'date'">
        {{ fmtDate(record.date) }}
      </template>

      <template v-else>
        {{ record[column.dataIndex] || '-' }}
      </template>
    </template>
  </a-table>
</template>


<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
defineEmits(["edit", "delete"]);

function fmtDate(d) {
  if (!d) return "-";
  try { return new Date(d + "T00:00:00").toLocaleDateString(); } catch { return d; }
}
function fmtTime(t) {
  if (!t) return "-";
  try {
    const [h, m] = t.split(":").map(n => parseInt(n, 10));
    const d = new Date(); d.setHours(h, m, 0, 0);
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch { return t; }
}
const columns = [
  { sorter: false },
  { title: "Name", dataIndex: "employee", key: "employee" },
  { title: "Job Title", dataIndex: "job_title", key: "job_title" },
  { title: "Date", dataIndex: "date", key: "date", sorter: { compare: (a, b) => (a.date || "").localeCompare(b.date || "") } },
  { title: "Shift", dataIndex: "shift_name", key: "shift" },
  { title: "Status", dataIndex: "published", key: "published" },
  { title: "User Available Timings", dataIndex: "User_Available", key: "User_Available" },
  { title: "", key: "action", sorter: false },
];

const dataSource = computed(() => props.rows.map(r => ({
  ...r,
  job_title: r.employee?.job_title || "-",
})));
</script>
